import cx from 'classnames'
import React from 'react'
import { BASE_CRM_URL } from 'shared/constants/defaultENV'

type Props = {
  id?: string
  children?: string | JSX.Element
  type?:
    | 'account'
    | 'contact'
    | 'opportunity'
    | 'lead'
    | 'changeRequest'
    | 'happyCall'
    | 'purchase'
    | 'invoice'
    | 'receipt'
    | 'quote'
    | 'phoneCall'
  href?: string
  customEtc?: number
  className?: string
} & React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>

const allEtc = {
  account: 1,
  contact: 2,
  lead: 4,
  opportunity: 3,
  changeRequest: 6,
  happyCall: 10590,
  purchase: 10027,
  invoice: 1090,
  receipt: 10029,
  quote: 1084,
  phoneCall: 4210,
}

function CrmLink(props: Props) {
  const {
    type,
    id,
    children,
    href: propsHref,
    customEtc,
    className,
    ...rest
  } = props

  const etc = type ? allEtc[type] : customEtc || ''

  const href =
    propsHref || `${BASE_CRM_URL}?etc=${etc}&pagetype=entityrecord&id=${id}`

  return (
    <a
      href={href}
      className={cx('focus-visible:outline-0', className)}
      onClick={(e) => {
        e.preventDefault()
        if (href)
          window.open(
            href,
            'Snopzer',
            'left=20,top=20,width=1360,height=768,toolbar=1,resizable=0'
          )
      }}
      {...rest}
    >
      {children}
    </a>
  )
}

export default CrmLink
